<template>
  <div>
    <el-upload
        action="none"
        ref="upload"
        list-type="picture-card"
        :multiple="multiple"
        :accept="accept"
        :file-list="postData"
        :on-success="onSuccess"
        :on-error="onError"
        :on-change="onChange"
        :on-exceed="onExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
        :limit="limit"
        :disabled="disabled"
    >
      <div slot="file" slot-scope="{file}">
<!--        todo  允许多个视频上传，进度条显示有问题-->
        <el-progress
            v-if="videoFlag == true"
            type="circle"
            :percentage="videoUploadPercent"
        ></el-progress>
        <img
            v-else
            class="el-upload-list__item-thumbnail"
            :src="file.url+'?x-oss-process=video/snapshot,t_10,f_jpg,w_0,h_0,m_fast,ar_auto'" alt=""
        >
        <span class="el-upload-list__item-actions">
        <span
            class="el-upload-list__item-preview"
            @click="onPreview(file)"
        >
          <i class="el-icon-video-play"></i>
        </span>
          <!--        <span-->
          <!--            v-if="!disabled"-->
          <!--            class="el-upload-list__item-delete"-->
          <!--            @click="handleDownload(file)"-->
          <!--        >-->
          <!--          <i class="el-icon-download"></i>-->
          <!--        </span>-->
        <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="onRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
      </div>
      <!--    <div>上传图片</div>-->
      <!--      <i class="el-icon-plus"></i>-->
      <!--      <div style="color: #666">上传视频</div>-->
      <i slot="default" class="el-icon-plus"></i>

    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <video style="width: 100%" controls="controls" :src="dialogImageUrl"/>
    </el-dialog>
  </div>
</template>
<script>
import OSS from 'ali-oss';

var client = {};
export default {
  name: 'VideoUploader',
  data() {
    return {
      postData: [],
      videoUploadPercent: 0,
      dialogImageUrl: '',
      dialogVisible: false,
      videoFlag: false,
      ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',
      ossFileURL: 'https://ccago.oss-cn-hangzhou.aliyuncs.com',
    }
  },
  props: {
    fileList: {
      type: Array,
      required: true,
    },
    accept: {
      type: String,
      default: 'video/*'
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    limit: {
      type: Number,
      default: 0,
    },
    drag: Boolean,
    disabled: Boolean,
    onError: Function,
    onChange: Function,
  },
  computed: {},
  mounted() {
    this.postData = this.fileList
  },
  watch: {
    fileList(value) {
      this.postData = value
    }
  },
  methods: {
    onRemove: function (file, fileList) {
      const that = this;
      this.fileList.forEach(function (element, index) {
        if (element.uid == file.uid) {
          that.fileList.splice(index, 1);
        }
      }, this);
    },

    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    onSuccess() {
      this.videoFlag = false
    },

    onProgress(event, file, fileList) {

      // this.videoFlag = true
      // this.videoUploadPercent = file.percentage.toFixed(0) * 1
      this.videoFlag = true;
      this.videoUploadPercent = parseInt(file.percentage);
      console.log(this.videoUploadPercent)
    },

    onExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    beforeUpload(file) {
      // 文件大小限制
      // const isLt5M = file.size / 1024 / 1024 < 16;
      // if (!isLt5M) {
      //   this.$message.error('不得超过16M');
      //   return false;
      // }

    },

    uploadFile(evt) {
      var that = this;
      console.log(that.ossFileURL);

      evt.onProgress({percent: 0});
      OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$message('上传异常:' + err);
          console && console.error(err);
          evt.onError(100);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert('parse sts response info error: ' + e.message);
        }

        client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];
        console.log(that.ossFileURL);
        var myDate = new Date().getTime();
        let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
        let date = that.dateFormat(myDate);
        var file_save_name = 'pc/' + date + '/' + time + '.' + suffix;
        console.log(file_save_name);

        client.multipartUpload(file_save_name, evt.file, {
          progress: function (p, checkpoint) {
            console.log('----上传进度----')
            let progress = parseInt(p * 100);
            evt.onProgress({percent: progress});
          },

        }).then(function (result) {
          evt.onSuccess();
          console.log(that.ossFileURL);
          var file = {
            url: that.ossFileURL + '/' + file_save_name,
            name: evt.file.name,
            save_name: file_save_name,
          }
          that.postData.push(file);

        }).catch(function (err) {
          console.log(err)
          that.$message({
            message: evt.file.name + '上传失败',
            type: 'warning',
          });
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// VideoUploader.vue?08f20f38